import { Direction, RotationAngle, CrossOrigin } from './types'

export function applyDirection(angle: RotationAngle, direction: Direction) {
  return ((angle + direction + 360) % 360) as RotationAngle
}

export async function canvasToObjectURL(canvas: HTMLCanvasElement) {
  return new Promise<string>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(URL.createObjectURL(blob))
      } else {
        reject()
      }
    })
  })
}

export async function loadImage(src: string, crossOrigin: CrossOrigin) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    image.onload = () => resolve(image)
    image.onerror = reject
    image.crossOrigin = crossOrigin ?? null
    image.src = src
  })
}

export async function rotateImage(
  src: string,
  crossOrigin: CrossOrigin,
  angle: RotationAngle,
) {
  const invert = [90, 270].includes(angle)

  const img = await loadImage(src, crossOrigin)

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (!context) throw new Error('2d context is unavailable')

  canvas.width = invert ? img.height : img.width
  canvas.height = invert ? img.width : img.height

  context.clearRect(0, 0, canvas.width, canvas.height)
  context.translate(canvas.width / 2, canvas.height / 2)
  context.rotate((angle * Math.PI) / 180)
  context.drawImage(img, -img.width / 2, -img.height / 2)

  return {
    src: await canvasToObjectURL(canvas),
    width: canvas.width,
    height: canvas.height,
  }
}
